import { render } from "./RewardHeroNew.vue?vue&type=template&id=3c7d1aa3&scoped=true"
import script from "./RewardHeroNew.vue?vue&type=script&lang=js"
export * from "./RewardHeroNew.vue?vue&type=script&lang=js"

import "./RewardHeroNew.vue?vue&type=style&index=0&id=3c7d1aa3&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c7d1aa3"]])

export default __exports__